import React from "react"
import { Helmet } from "react-helmet";
import Layout from "@Components/layout";
import { useStaticQuery, graphql } from "gatsby";
import SEO from "@Components/seo";
import { Container } from 'react-bootstrap';
import StaticContactBlock from '@Components/Static/StaticContactBlock/StaticContactBlock'
import MemberDetails from '@Components/Static/MemberDetails/MemberDetails'
import ContentBlockText from '@Components/Static/ContentBlockText/ContentBlockText'
import { useQuery } from '@apollo/client';
import gql from "graphql-tag"
import BreadcrumbsBottom from "@Components/Static/BreadcrumbsBottom/BreadcrumbsHome";
import ContactBlock from "../Components/ContactBlock/ContactBlock"
import { navigate } from "@reach/router"
import { useLocation } from "@reach/router"

const OurTeam = (props) => {
    const GET_TEAM_MEMBER = gql`
  query GetTeam($URL: String!){	
    teams(where:{URL: $URL}){
        id
        imagetransforms
      Name
      Phone
      About
      URL
      Email
      Image {
        url
        alternativeText
      }
      ggfx_results {
          transforms
          src_url
          src_cftle
      }
      Embed_Video_URL
      Book_A_Video
      Designation
      Meta_Title
      Meta_Description
    }
  }
`;
    const officeData = useStaticQuery(graphql`
      query{
        glstrapi {
            offices(publicationState: LIVE) {  
                Name
                Address
                Email
                Phone
                Whatsapp 
                latitude
                longitude
            }
        }
      } `);
    const offices = officeData.glstrapi?.offices;


    const contactBlockContent = {
        "id": "6824756b7848650d288ea1eb",
        "ContactTitle": "Let’s talk",
        "Content": "<p>If you’re looking to buy, sell, let, or simply have questions, our team is here to help. Get in touch with our local experts in Manchester or Hale</p>",
        "Ctas": [
            {
                "Cta_Label": "Book a valuation",
                "Cta_URL": {
                    "URL": "book-a-valuation",
                    "Secondary_URL": null
                }
            }
        ],
        "Offices": offices
    }

    const { loading, data } = useQuery(GET_TEAM_MEMBER, {
        variables: { URL: props.slug }
    });

    var { pathname } = useLocation()
    var profileUrl = ""
    profileUrl = process.env.GATSBY_SITE_URL + pathname

    if (data?.teams?.length == 0) {
        navigate('/about-us/our-team/');
    }

    if (loading) return (
        <div className="static-news gql-loading-screen">
            <Container>
                <div className="gql-loading"><div className="dot-pulse"></div></div>
            </Container>
        </div>);
    return (
        <Layout css={true} breadCrumPage={data?.teams[0]?.Name} class="static" breadCrumAlias={'our-team'} type="details-page">
            {data?.teams.map((Page, i) => {
                return (
                    <>
                        <SEO title={Page ? Page.Name + ' | ' + Page.Designation : ''} description={'Know about ' + Page.Name + ', ' + Page.Designation + ' here. We are here to help you with the property solutions.'} />
                        <Helmet
                            bodyAttributes={{
                                class: `templates-team-details-template homepage`
                            }}
                        />
                        <MemberDetails data={Page} />
                        <ContentBlockText isTeam={false} data={Page?.About} />
                        <ContactBlock {...contactBlockContent} />
                        <Helmet>
                            <script type="application/ld+json">{`
                        { 
                        "@context": "https://schema.org",
                        "@type": "RealEstateAgent",
                        "name": "${Page?.Name}",
                        "jobTitle": "${Page?.Designation}",
                        "description": "Know about ${Page?.Name}, ${Page?.Designation} here. We are here to help you with the property solutions.",
                        "telephone": "${Page?.Phone}",
                        "email": "${Page?.Email}",
                        "url": "${profileUrl}",
                        "areaServed": {
                            "@type": "Country",
                            "name": "United Kingdom"
                        },
                        "image": "${Page?.Image?.url}"  
                        }
                        
                        `}</script>
                        </Helmet>

                    </>

                )
            })}
        </Layout>
    );
}

export default OurTeam